import type * as React from 'react';

export const SEARCH_HIGHLIGHT_PRE_TAG = '<gb-search-highlight>';
export const SEARCH_HIGHLIGHT_POST_TAG = '</gb-search-highlight>';
/**
 * This component is used to highlight text in a string which are denoted by
 * the SEARCH_HIGHLIGHT_PRE_TAG and SEARCH_HIGHLIGHT_POST_TAG.
 */
export function SearchTextHighlight(props: {
    value: string;
    maxLength?: number;
    standout?: boolean;
}): React.ReactElement {
    const { value, maxLength = Number.POSITIVE_INFINITY, standout } = props;
    const parts = getHighlightedParts(value, maxLength);

    if (standout) {
        return (
            <span className="text-ui-action">
                Ask <span className="text-base">&ldquo;{value}&rdquo;</span> using GitBook AI?
            </span>
        );
    }

    return (
        <>
            {parts.map((part, i) => (
                <span
                    key={i}
                    className={part.isHighlighted ? 'font-medium text-primary' : undefined}
                >
                    {part.value}
                </span>
            ))}
        </>
    );
}

function getHighlightedParts(value: string, maxLength: number) {
    const splitByPreTag = value.split(SEARCH_HIGHLIGHT_PRE_TAG);
    const elements: Array<{
        isHighlighted: boolean;
        value: string;
    }> = [];

    let charsLeft = maxLength;

    const pushElement = (text: string, isHighlighted: boolean) => {
        if (charsLeft <= 0) {
            return;
        }
        const chunk = text.slice(0, charsLeft);
        charsLeft -= chunk.length;

        elements.push({
            value: chunk.length < text.length ? `${chunk}…` : chunk,
            isHighlighted,
        });
    };

    const firstValue = splitByPreTag.shift();
    if (firstValue) {
        pushElement(firstValue, false);
    }

    for (const split of splitByPreTag) {
        const splitByPostTag = split.split(SEARCH_HIGHLIGHT_POST_TAG);

        if (charsLeft <= 0) {
            break;
        }

        pushElement(splitByPostTag[0], true);

        if (splitByPostTag[1] !== '') {
            pushElement(splitByPostTag[1], false);
        }
    }

    return elements;
}
